import { useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { WidgetProps } from '@rjsf/utils';
import { format, isValid } from 'date-fns';
import { DetailRow } from '../../../DetailsDrawer/DetailRow';
import { getDate } from '../../../../../utils/helpers';

export const DateInput = (props: WidgetProps) => {
  const { value: formValue, onChange } = props;
  const parseDate = (val: unknown): Date | null => {
    const d = getDate(val);
    return isValid(d) ? d : null;
  };
  const [value, setValue] = useState<Date | null>(parseDate(formValue));
  const [dirty, setDirty] = useState(false);

  const handleChange = (val: Date | null) => {
    if (!dirty) setDirty(true);
    if (val === null || (val instanceof Date && isNaN(Date.parse(val?.toString())))) {
      setValue(null);
      onChange(null);
    } else {
      setValue(val);
      onChange(format(val, 'yyyy-MM-dd'));
    }
  };

  const getHelperText = () => {
    if (isErrorState()) return `${props.label} required`;
  };

  const isErrorState = () => {
    return dirty && ((props.rawErrors && props.rawErrors.length > 0) || (value === null && props.required));
  };

  if (props.readonly) {
    if (props.formContext?.hideEmpty && !formValue) return null;

    return (
      <div>
        <DetailRow
          key={props.id}
          colId={props.id}
          title={props.uiSchema?.['ui:placeholder'] || ''}
          value={formValue || ''}
        />
      </div>
    );
  }

  return (
    <DatePicker
      value={value}
      slotProps={{
        textField: {
          required: props.required,
          error: isErrorState(),
          helperText: getHelperText(),
          name: props.uiSchema?.['ui:placeholder'],
          size: props.uiSchema?.['ui:size'],
          fullWidth: props.uiSchema?.['ui:fullWidth'] || false
        }
      }}
      onChange={handleChange}
      label={props.uiSchema?.['ui:placeholder']}
    />
  );
};
